import { usePlan } from '../plan/usePlan';
import { EMPTY_REGISTRIES, tagTint } from '../plan/registries';
import { tagTones } from './tagPalette';
import { useTheme } from './useTheme';

/** The ground a page stands on when it is in [tag]: that tag's ground tone,
 *  or undefined for no tag, or one with no colour. */
export function useTagGround(tag: string | null | undefined): string | undefined {
  const { plan } = usePlan();
  const { theme } = useTheme();
  const registries = plan.status === 'ready' ? plan.plan.registries : EMPTY_REGISTRIES;
  const hue = tag ? tagTint(registries, tag) : null;
  return hue ? tagTones(theme, hue).ground : undefined;
}
